export default __webpack_public_path__ + "static/media/HRA0233_Hana_webinar_certificate.74e9dd31.png";